export default __webpack_public_path__ + "static/favicon-2439cdcb622c0aa27bc1f9107126bfe9.ico";